/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */
import { api } from 'utils/index';

export default {
    state: {
        items: null,
    },
    reducers: {
        fetchResponse: (state, payload) => ({ ...state, items: payload }),
    },
    effects: {
        async fetchHome() {
            await api.get('home')
                .then(response => this.fetchResponse(response));
        },
    },
};
